import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

import { isAuthenticated } from '../../../store/selectors/AuthSelectors';

// Action type (inline)
const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
const baseURL = process.env.REACT_APP_API_BASE_URL;
// Inline logout action creator (Thunk)
const logoutUser = (navigate) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        dispatch({ type: LOGOUT_SUCCESS });
        navigate('/login');
        return;
      }

      await axios.post(`${baseURL}/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });

      localStorage.removeItem('token');
      dispatch({ type: LOGOUT_SUCCESS });
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      navigate('/login');
    }
  };
};

// withRouter HOC (unchanged)
function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }
  return ComponentWithRouterProp;
}

function LogoutPage(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onLogout = () => {
    dispatch(logoutUser(navigate));
  };

  return (
    <>
      <button className="dropdown-item ai-icon ms-1 log-btn" onClick={onLogout}>
        <i className="fa-solid fa-arrow-right-from-bracket fs-6 text-gray-400"></i>
        <span className="ms-2 fs-7">Logout</span>
      </button>
    </>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated(state),
});

export default withRouter(connect(mapStateToProps)(LogoutPage));
